import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import DashboardViewService from '../../services/dashboardview.service';

const booleanOptions = [
  { value: true, label: 'True' },
  { value: false, label: 'False' },
];

const statusOptions = [
  { value: 'Enabled', label: 'Enabled' },
  { value: 'Disabled', label: 'Disabled' },
]

const modeOptions = [
  { value: "Publish", label: 'Publish' },
  { value: "Subscribe", label: 'Subscribe' },
];

const device_typeOptions = [
  { value: "Radix-EFM", label: 'Radix-EFM' },
  { value: "Radix-Controller", label: 'Radix-Controller' },
  { value: "Other", label: 'Other' },
];

const gatewaytypeOptions = [
  { value: "Radix-gprs", label: 'Radix-gprs' },
  { value: "Radix-lora", label: 'Radix-lora' },
  { value: "Radix-wan/lan", label: 'Radix-wan/lan' },
];

function hasBlankOrNullValues(obj) {
  for (const key in obj) {
    const value = obj[key];

    if (value === null || value === '') {
      return true; // Found a blank or null value
    }

    if (typeof value === 'string') {
      // Try parse JSON string to object and check recursively
      try {
        const parsed = JSON.parse(value);
        if (typeof parsed === 'object' && parsed !== null) {
          if (hasBlankOrNullValues(parsed)) {
            return true;
          }
        }
      } catch {
        // Not a JSON string, ignore
      }
    } else if (typeof value === 'object' && value !== null) {
      // Normal object recursion
      if (hasBlankOrNullValues(value)) {
        return true;
      }
    }
  }

  return false; // No blank or null values found
}

// Check for the values are within min max range or not
function isWithinMinMaxRanges(data, ranges, exclude) {
  for (const key in data) {
    // Skip checking for values in the exclude array
    if (exclude.includes(key)) {
      continue;
    }

    if (key in ranges) {
      const { min, max } = ranges[key];
      if (data[key] < min || data[key] > max) {
        return false; // Value is outside the specified range
      }
    }
  }
  return true; // All values are within their respective ranges
}

function SaveChangesDialog(props) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {

    setOpen(true);
    
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccessClose = () => {
    setOpenSuccessDialog(false);
    props.success(true);
  };

  const handleFildClose = () => {
    setOpenFaildialog(false);
  };
  

  const [message, setMessage] = useState();

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openFaildialog, setOpenFaildialog] = useState(false);

  const [saveData, setSaveData] = useState(false);
  const handleClickSaveChanges = () => { 
     setSaveData(true);
     };

  //  Edit row to mqttclientconfig collection 
  useEffect(() =>{
    async function saveRowData()  {
    try {

      let dashboardName = "DashboardConfig"
      let data = props.rowData;
      console.log(data)

      // Check for value is within range or not
      const minMaxRanges = {
        qos: { min: 0, max: 2},
        retain_handling: { min: 0, max: 2},
        interval: { min: 1, max: 100 },
      };
      const valuesToExclude = ['Status', 'client_id', 'Mode', 'device_type', 'topic_name', 'retain', 'payload_type',
        'payload_template'];
      if (isWithinMinMaxRanges(data, minMaxRanges, valuesToExclude)) {
        
        // Blank value check for the  one of the form field
        if (hasBlankOrNullValues(data)) {
          setOpenFaildialog(true);
          setMessage("One of the field is blank inside the form, please correct it.");
          setSaveData(false);
          setOpen(false); // Close "Save changes" window

        } else {
          const response = await DashboardViewService.updateRowData(dashboardName, data);  // create new record if id is not present in array data ie existing data
          if(response){
            setOpenSuccessDialog(true);
            setMessage("Record Edited Successfully");
            setSaveData(false);
            setOpen(false); // Close "Save changes" window
    
          }

        }

      } else {

        setOpenFaildialog(true);
        setMessage("One of the field (retain_handling, interval) is out of min max range. Plese correct the same.");
        setSaveData(false);
        setOpen(false); // Close "Save changes" window

      }

    } catch (error) {
      setOpenFaildialog(true);
      setMessage("Error While Editing Record, Please very all parameters entered in form");
      setOpen(false); // Close "Save changes" window
      console.log(error);


    }
  };
  if(saveData){
    saveRowData();
    setSaveData(false);
  };


  }, [saveData]);
  

  return (
    
    <div>
      <Button variant="contained" startIcon ={<SaveIcon/>} sx={{mt:1}} onClick={handleClickOpen}>SAVE </Button>
      
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>SAVE CHANGES</DialogTitle>
        <Box sx={{width: 400 }}>
        <DialogContent dividers>
          <DialogContentText>
            Are you sure to edit the new mqtt topic configuration.
          </DialogContentText>
          
        </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClickSaveChanges}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Success dialog after upgradtion of teh user info. */}
      <Dialog
        open={openSuccessDialog}
        onClose={handleSuccessClose}
       
      >
        <DialogTitle > success.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Save Changes Failed dialog /Wrong Password */}
      <Dialog
        open={openFaildialog}
        onClose={handleFildClose}
       
      >
        <DialogTitle > Failed.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFildClose}>Close</Button>
        </DialogActions>
      </Dialog>


    </div>
  );
}

export default function DashboardConfigEdit({params, open, close}){

  const { user } = useSelector((state) => state.auth);
  const [config, setConfig] = useState({
    Status: params.row.Status,
    client_id: params.row.client_id,
    Mode: params.row.Mode,
    device_type: params.row.device_type,
    topic_name: params.row.topic_name,
    qos: params.row.qos,
    retain: params.row.retain,
    retain_handling: params.row.retain_handling,
    gateway_type: params.row.gateway_type,
    payload_template: params.row.payload_template,
    interval: params.row.interval,
    device_type: params.row.device_type,
    Radix_EFM_ToT_Pos: params.row.Radix_EFM_ToT_Pos,
    Radix_EFM_ToT_Pos_Fraction: params.row.Radix_EFM_ToT_Pos_Fraction,
    Radix_EFM_ToT_Neg: params.row.Radix_EFM_ToT_Neg,
    Radix_EFM_ToT_Neg_Fraction: params.row.Radix_EFM_ToT_Neg_Fraction,
    Radix_EFM_ToT: params.row.Radix_EFM_ToT,

    _id:params.row._id,
    email: user.email,
    role: user.role,
    PWDInterlock:"Disabled",
    EventStatus:"Disabled",
  });

  // Get  All client_id from mqttclientconfig
  const [clientIdList, setClientIdList] = useState([]);   
  
  useEffect(() =>{
    async function getAllRowsData()  {
    try {

      let dashboardName = "MqttClientConfig"

      setClientIdList([]);
      const response = await DashboardViewService.getAllRowsData(dashboardName);
      if (response){
  
        setClientIdList(response.data.map((item) => item.client_id)); 
      }
      
      
    } catch (error) {
      console.log(error);

    }
  }
    getAllRowsData();

  }, []);

  // Initialize the JSON string from config
  const [jsonError, setJsonError] = useState(false);
  const [jsonString, setJsonString] = useState('');
  useEffect(() => {
    setJsonString(JSON.stringify(config.payload_template, null, 2));
  }, [config.payload_template]);

  const handleJsonChange = (e) => {
    const val = e.target.value;
    setJsonString(val); // update text field

    try {
      const parsed = JSON.parse(val);
      setConfig((prev) => ({
        ...prev,
        payload_template: parsed
      }));
      setJsonError(false);
    } catch {
      setJsonError(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const isBooleanField = [
      'Status',
      'retain',
    ].includes(name);
    const parsedValue = isBooleanField ? value === 'true' : value;
    setConfig((prev) => ({ ...prev, [name]: parsedValue }));
  };

  const handleRecordSaveSuccess = (data) =>{
    close(data)
  }

  return (
    <>

      <Dialog
        open={open}
        onClose={close}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          Edit Mqtt Topic Configuration
          <IconButton
            aria-label="close"
            onClick={close}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box component="form">
            <Grid container spacing={2}>
              {/* Ordered fields */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Topic Status"
                  name="Status"
                  value={String(config.Status)}
                  onChange={handleChange}
                >
                  {statusOptions.map((option) => (
                    <MenuItem key={option.label} value={String(option.value)}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="client-id-label">Client ID</InputLabel>
                  <Select
                    labelId="client-id-label"
                    id="client_id"
                    name="client_id"
                    value={config.client_id}
                    label="Client ID"
                    onChange={handleChange}
                  >
                    {clientIdList.map((id) => (
                      <MenuItem key={id} value={id}>
                        {id}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Topic Name" name="topic_name" value={config.topic_name} disabled={true} onChange={handleChange} />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Mode"
                  name="Mode"
                  value={String(config.Mode)}
                  onChange={handleChange}
                >
                  {modeOptions.map((option) => (
                    <MenuItem key={option.label} value={String(option.value)}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="QOS" name="qos" type="number" InputProps={{inputProps: {min: 0, max: 2,},}} value={config.qos} onChange={handleChange} />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Interval" name="interval" type="number" InputProps={{inputProps: {min: 1, max: 60,},}} value={config.interval} onChange={handleChange} />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Retain"
                  name="retain"
                  value={String(config.retain)}
                  onChange={handleChange}
                >
                  {booleanOptions.map((option) => (
                    <MenuItem key={option.label} value={String(option.value)}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Retain Handling" name="retain_handling" type="number" InputProps={{inputProps: {min: 0, max: 1,},}} value={config.retain_handling} onChange={handleChange} />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Gateway Type"
                  name="gateway_type"
                  value={String(config.gateway_type)}
                  onChange={handleChange}
                >
                  {gatewaytypeOptions.map((option) => (
                    <MenuItem key={option.label} value={String(option.value)}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Devie Type"
                  name="device_type"
                  value={String(config.device_type)}
                  onChange={handleChange}
                >
                  {device_typeOptions.map((option) => (
                    <MenuItem key={option.label} value={String(option.value)}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {config.device_type === "Radix-EFM" && (
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Radix-EFM:Totalizer+ Key Name" name="Radix_EFM_ToT_Pos" type="text" value={config.Radix_EFM_ToT_Pos} onChange={handleChange} />
                </Grid>
              )}
              {config.device_type === "Radix-EFM" && (
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Radix-EFM:Totalizer+FRAC Key Name" name="Radix_EFM_ToT_Pos_Fraction" type="text" value={config.Radix_EFM_ToT_Pos_Fraction} onChange={handleChange} />
                </Grid>
              )}
              {config.device_type === "Radix-EFM" && (
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Radix-EFM:Totalizer- Key Name" name="Radix_EFM_ToT_Neg" type="text" value={config.Radix_EFM_ToT_Neg} onChange={handleChange} />
                </Grid>
              )}
              {config.device_type === "Radix-EFM" && (
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Radix-EFM:Totalizer-FRAC Key Name" name="Radix_EFM_ToT_Neg_Fraction" type="text" value={config.Radix_EFM_ToT_Neg_Fraction} onChange={handleChange} />
                </Grid>
              )}
              {config.device_type === "Radix-EFM" && (
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Radix-EFM:Totalizer Key Name" name="Radix_EFM_ToT" type="text" value={config.Radix_EFM_ToT} onChange={handleChange} />
                </Grid>

              )}

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  label="JSON Key : TagName"
                  name="payload_template"
                  value={jsonString}
                  onChange={handleJsonChange}
                  error={jsonError}
                  helperText={jsonError ? "Invalid JSON format" : "JSON object"}
                  //disabled={config.device_type !== "Radix-EFM"}
                />
              </Grid>

            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={close} sx={{mt:1}} >Cancel</Button>
          
          <SaveChangesDialog
          rowData = {config}
          success = {handleRecordSaveSuccess}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

